import {
  TOGGLE_LOADING,
  UPDATE_DATA,
  SET_EXPANDED_GROUP,
  UPDATE_DEVICE_PROPERTIES,
  UPDATE_USER_GROUP,
  UPDATE_FILTERER,
  SELECT_DEVICE,
  CLEAR_DEVICE,
  UPDATE_DOWNLOAD_PROGRESS,
  SHOW_DATA_DOWNLOAD_FAILED,
  CLOSE_DOWNLOAD_EXCEL,
  UPDATE_CHIDREN_OF_USER,
  UPDATE_PROPERTY_CHILDREN_USER
} from '../actions/devicesPage.action'
import { isObject, isNil, isArray } from 'lodash'

const initState = {
  data: [],
  pages: null,
  total: null,
  loading: false,
  numGroup: 0,
  expanderGroup: {},
  deviceProperties: {},
  userGroup: {},
  numberGroup: null,
  filter: null,
  deviceSelected: null,
  download: null
}

export default function devicesPageReducer(state = initState, action) {
  switch (action.type) {
    case TOGGLE_LOADING: {
      return {
        ...state,
        loading: !state.loading
      }
    }
    case UPDATE_DATA: {
      const groupObj = {}
      for (let index = 0; index < action.data.length; index++) {
        const element = action.data[index]
        const { parentsInfo } = element
        if (!isObject(parentsInfo)) {
          groupObj['no_parent'] = isNil(groupObj['no_parent'])
            ? 1
            : groupObj['no_parent'] + 1
          continue
        }
        groupObj[parentsInfo._id] = isNil(groupObj[parentsInfo._id])
          ? 1
          : groupObj[parentsInfo._id] + 1
      }
      let count = 0
      for (const key in groupObj) {
        if (groupObj.hasOwnProperty(key)) {
          count += 1
        }
      }
      const expanded = {}
      for (let index = 0; index < count; index++) {
        expanded[index + ''] = true
      }
      return {
        ...state,
        pages: isNil(action.pages) ? state.pages : action.pages,
        total: isNil(action.total) ? state.total : action.total,
        data: action.data,
        numGroup: count,
        expanderGroup: expanded
      }
    }
    case SET_EXPANDED_GROUP: {
      return {
        ...state,
        expanderGroup: action.newExpander
      }
    }
    case UPDATE_DEVICE_PROPERTIES: {
      return {
        ...state,
        deviceProperties: action.deviceProperties
      }
    }
    case UPDATE_USER_GROUP: {
      return {
        ...state,
        userGroup: action.users,
        numberGroup: Object.keys(action.users).length
      }
    }
    case UPDATE_FILTERER: {
      return {
        ...state,
        filter: action.filter
      }
    }
    case SELECT_DEVICE: {
      return {
        ...state,
        deviceSelected: action.device
      }
    }
    case CLEAR_DEVICE: {
      return {
        ...state,
        deviceSelected: null
      }
    }
    case UPDATE_DOWNLOAD_PROGRESS: {
      const newData = isNil(state.download)
        ? action.data
        : [...state.download.data, ...action.data]
      return {
        ...state,
        download: {
          data: newData,
          numberItems: isArray(newData) ? newData.length : 0,
          limit: action.limit || state.download.limit,
          page: action.page,
          total: action.total || state.download.total,
          filtered: action.filtered || state.download.filtered
        }
      }
    }
    case SHOW_DATA_DOWNLOAD_FAILED: {
      return {
        ...state,
        download: {
          ...state.download,
          error: action.error
        }
      }
    }
    case CLOSE_DOWNLOAD_EXCEL: {
      return {
        ...state,
        download: null
      }
    }
    case UPDATE_CHIDREN_OF_USER: {
      const { children, parentId } = action
      const { userGroup } = state
      if (!isObject(userGroup) || !userGroup[parentId]) {
        return state
      }
      return {
        ...state,
        userGroup: {
          ...userGroup,
          [parentId]: {
            ...userGroup[parentId],
            children
          }
        }
      }
    }
    case UPDATE_PROPERTY_CHILDREN_USER: {
      const { parentId, key, value } = action
      const { userGroup } = state
      if (!isObject(userGroup) || !userGroup[parentId]) return state
      return {
        ...state,
        userGroup: {
          ...userGroup,
          [parentId]: {
            ...userGroup[parentId],
            [key]: value
          }
        }
      }
    }
    default:
      return state
  }
}
